type ValueOf<T> = T[keyof T];
type JSONParse = ValueOf<Pick<JSON, 'parse'>>;
type Params = Parameters<JSONParse>;

type SafelyParseJSONResult<T> = {
  value?: T;
  error?: any;
};

const safelyParseJSON = <T>(text: Params[0], reviver?: Params[1]): SafelyParseJSONResult<T> => {
  try {
    return {
      value: JSON.parse(text, reviver),
    };
  } catch (error) {
    return {
      error,
    };
  }
};

export default safelyParseJSON;
